<template>
  <CContainer class="out-of-office-view datatable-container mb-5">
    <Loader :is-processing="isLoading" />

    <CRow class="mt-5">
      <CCol md="12">
        <div
          class="table-tabs-header mb-2 bg-white d-flex align-items-center justify-content-between"
        >
          <div class="d-flex">
            <div v-for="(tab, index) in tableTabs" :key="index">
              <div
                :class="{ active: tab.value === filterParams.activeTab.value }"
                class="table-tab"
                @click="setActiveTableTab(tab)"
              >
                {{ tab.label }}
              </div>
            </div>
            <div>
              <VSelect
                v-if="gradeYears"
                v-model="filterParams.grade_years"
                class="cs-select width-200-px mt-2 ms-2"
                :options="gradeYears"
                placeholder="Select year"
                :clearable="false"
                :searchable="false"
                @update:model-value="setCalendarDates"
              />
            </div>
          </div>
          <div class="actions d-flex align-items-center">
            <div
              class="lh-normal cursor-pointer text-accent-blue-light"
              @click="handlePolarities(pagination.activePage, true)"
            >
              <i class="fi flaticon-download me-1" />
              <span class="d-none d-md-inline-block">Download CSV</span>
            </div>

            <div
              class="d-flex align-items-center search-field mb-0 ms-2 ms-md-4"
            >
              <CInputGroup class="w-auto">
                <div class="input-group-prepend">
                  <span class="input-group-text lh-normal"
                    ><div><i class="flaticon-magnifying-glass"></i></div
                  ></span>
                </div>
                <CFormInput
                  placeholder="Search..."
                  v-model="columnSearchKeys.globalQuery"
                  @input="searchByQuery($event.target.value)"
                >
                  >
                </CFormInput>
              </CInputGroup>
            </div>
          </div>
        </div>
        <div class="status-guides-container justify-content-between mb-2">
          <CCheckBox
            label="Student Number"
            v-model="filterParams.student_sis_id"
            name="Student number"
            class="custom-checkbox"
            :inline="true"
            :custom="true"
          />
          <per-page-selector :action="setPerPage" :pagination="pagination" />
        </div>
        <DataTable
          v-if="polarities"
          class="datatable bg-white"
          :items="polarities"
          :fields="activeDataTableFields"
          :sorter="{ external: true }"
          column-filter
          :no-items-view="{
            noResults: 'No items available',
            noItems: 'No items available'
          }"
          @update:sorter-value="sortByColumn"
        >
          <template #first_student_sis_id="{ item }">
            <td>
              <div>
                {{
                  item.first_user && item.first_user.student_sis_id
                    ? item.first_user.student_sis_id
                    : ""
                }}
              </div>
            </td>
          </template>
          <template #first_user="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.first_user
                    ? item.first_user.first_name +
                      " " +
                      item.first_user.last_name
                    : "-"
                }}
              </p>
            </td>
          </template>
          <template #first_user-filter>
            <input
              v-model="columnSearchKeys.first_user.value"
              placeholder="Search by name"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #second_student_sis_id="{ item }">
            <td>
              <div>
                {{
                  item.second_user && item.second_user.student_sis_id
                    ? item.second_user.student_sis_id
                    : ""
                }}
              </div>
            </td>
          </template>

          <template #second_user="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.second_user
                    ? item.second_user.first_name +
                      " " +
                      item.second_user.last_name
                    : "-"
                }}
              </p>
            </td>
          </template>
          <template #second_user-filter>
            <input
              v-model="columnSearchKeys.second_user.value"
              placeholder="Search by name"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #times_triggered="{ item }">
            <td>
              {{ item.times_triggered }}
            </td>
          </template>
          <template #times_triggered-filter>
            <input
              v-model="columnSearchKeys.times_triggered.value"
              placeholder="Search by times triggered"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #message="{ item }">
            <td class="comments-column">
              <div class="comments-list">
                <div class="comment">
                  {{ item.message ? item.message : "" }}
                </div>
              </div>
            </td>
          </template>
          <template #message-filter>
            <input
              v-model="columnSearchKeys.message.value"
              placeholder="Search by note"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #created_at="{ item }">
            <td>
              {{
                item.created_at
                  ? $helpers.transformDate(item.created_at, "MM/DD/YYYY")
                  : "-"
              }}
            </td>
          </template>
          <template #created_at-filter>
            <input
              v-model="columnSearchKeys.created_at.value"
              placeholder="Search by date"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #status="{ item }">
            <td>
              <b
                class="limit-status cursor-pointer"
                :class="item.status ? 'active' : 'inactive'"
                @click="updatePolarityStatus(item.id)"
                >{{ item.status ? "active" : "inactive" }}</b
              >
            </td>
          </template>
          <template #status-filter>
            <input
              v-model="columnSearchKeys.status.value"
              placeholder="Search by status"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #actions="{ item }">
            <td>
              <div class="d-flex">
                <button class="btn btn-cancel" @click="deletePolarity(item.id)">
                  delete
                </button>
              </div>
            </td>
          </template>

          <template #user="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.user
                    ? item.user.first_name + " " + item.user.last_name
                    : "-"
                }}
              </p>
            </td>
          </template>
          <template #user-filter>
            <input
              v-model="columnSearchKeys.user.value"
              placeholder="Search by name"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>
          <template #prevented_student_sis_id="{ item }">
            <td>
              <div>
                {{
                  item.user && item.user.student_sis_id
                    ? item.user.student_sis_id
                    : ""
                }}
              </div>
            </td>
          </template>

          <template #destination="{ item }">
            <td>
              <p class="m-0">
                {{ item.destination ? item.destination.name : "-" }}
              </p>
            </td>
          </template>
          <template #destination-filter>
            <input
              v-model="columnSearchKeys.destination.value"
              placeholder="Search by destination"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #out_user="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.out_user
                    ? item.out_user.first_name + " " + item.out_user.last_name
                    : "-"
                }}
              </p>
            </td>
          </template>
          <template #out_user-filter>
            <input
              v-model="columnSearchKeys.out_user.value"
              placeholder="Search by name"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>
          <template #out_student_sis_id="{ item }">
            <td>
              <div>
                {{
                  item.out_user && item.out_user.student_sis_id
                    ? item.out_user.student_sis_id
                    : ""
                }}
              </div>
            </td>
          </template>

          <template #prevented_from-filter>
            <input
              v-model="columnSearchKeys.prevented_from.value"
              placeholder="Search by location"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #report_created_at="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.prevented_at
                    ? $helpers.transformDate(item.prevented_at, "MM/DD/YYYY")
                    : ""
                }}
              </p>
            </td>
          </template>
          <template #report_created_at-filter>
            <input
              v-model="columnSearchKeys.report_created_at.value"
              placeholder="Search by date"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>

          <template #prevented_at="{ item }">
            <td>
              <p class="m-0">
                {{
                  item.prevented_at
                    ? $helpers.transformDate(item.prevented_at, "h:mm A")
                    : ""
                }}
              </p>
            </td>
          </template>
          <template #prevented_at-filter>
            <input
              v-model="columnSearchKeys.prevented_at.value"
              placeholder="Search by time"
              class="form-control form-control-sm my-2"
              @input="searchByQuery($event.target.value, 'column')"
            />
          </template>
        </DataTable>

        <Pagination
          v-if="pagination.pages && pagination.pages > 1 && !isLazyLoadingMode"
          class="cs-pagination mt-4"
          :dots="false"
          :double-arrows="true"
          :active-page="pagination.activePage"
          :pages="pagination.pages"
          size="lg"
          align="center"
          @update:active-page="setActivePage"
        >
          <template #last-button>
            <i class="flaticon-right-arrow-1" />
          </template>
          <template #first-button>
            <i class="flaticon-left-arrow-2" />
          </template>
          <template #previous-button>
            <i class="fi flaticon-left-arrow-1" />
          </template>
          <template #next-button>
            <i class="fi flaticon-chevron" />
          </template>
        </Pagination>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
import Loader from "@/components/Loader"
import { mapGetters } from "vuex"
import PerPageSelector from "../PerPageSelector.vue"
import moment from "moment-timezone"

export default {
  name: "PolaritiesDataTable",
  components: {
    Loader,
    PerPageSelector
  },
  data() {
    return {
      isLazyLoadingMode: false,
      columnSearchKeys: {
        globalQuery: "",
        first_user: {
          value: "",
          column: ["first_user.name"],
          sortBy: "first_user.name"
        },
        second_user: {
          value: "",
          column: ["second_user.name"],
          sortBy: "second_user.name"
        },
        times_triggered: {
          value: "",
          column: ["times_triggered"],
          sortBy: "times_triggered"
        },
        message: { value: "", column: ["message"], sortBy: "message" },
        created_at: {
          value: "",
          column: ["created_at.raw"],
          sortBy: "created_at"
        },
        status: { value: "", column: ["status_string"], sortBy: "status" },

        user: { value: "", column: ["user.name"], sortBy: "user.name" },
        destination: {
          value: "",
          column: ["destination.name"],
          sortBy: "destination.name"
        },
        out_user: {
          value: "",
          column: ["out_user.name"],
          sortBy: "out_user.name"
        },
        prevented_from: {
          value: "",
          column: ["prevented_from"],
          sortBy: "prevented_from"
        },
        report_created_at: {
          value: "",
          column: ["prevented_at.raw"],
          sortBy: "prevented_at"
        },
        prevented_at: {
          value: "",
          column: ["prevented_time.raw"],
          sortBy: "prevented_time"
        }
      },
      filterParams: {
        search_query: "",
        sort_query: "",
        activeTab: "",
        grade_years: [],
        dates: {
          end: moment().format("MMM DD YYYY"),
          start: moment().format("MMM DD YYYY")
        },
        student_sis_id: false
      },
      pagination: {
        activePage: 1,
        total: 0,
        pages: 0,
        per_page: { label: "25", value: 25 }
      },
      dataTableFields: [
        {
          key: "first_student_sis_id",
          filter: false,
          sorter: false,
          label: "Student A number",
          _style: "min-width:150px"
        },
        { key: "first_user", _style: "min-width:110px", label: "Student A" },
        {
          key: "second_student_sis_id",
          filter: false,
          sorter: false,
          label: "Student B number",
          _style: "min-width:150px"
        },
        { key: "second_user", _style: "min-width:110px", label: "Student B" },
        {
          key: "times_triggered",
          _style: "min-width:150px",
          label: "# of times triggered"
        },
        { key: "message", _style: "min-width:150px", label: "Admin Only Note" },
        { key: "created_at", _style: "min-width:150px", label: "Date Created" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions", filter: false },
        {
          key: "prevented_student_sis_id",
          filter: false,
          sorter: false,
          label: "Student A number",
          _style: "min-width:150px",
          AdvancedReport: true
        },
        { key: "user", label: "Student Prevented", AdvancedReport: true },
        { key: "destination", label: "Destination", AdvancedReport: true },
        {
          key: "out_student_sis_id",
          filter: false,
          sorter: false,
          label: "Student B number",
          _style: "min-width:150px",
          AdvancedReport: true
        },
        {
          key: "out_user",
          label: "Student on active Pass",
          AdvancedReport: true
        },
        { key: "prevented_from", label: "Attempt from", AdvancedReport: true },

        { key: "report_created_at", label: "Date", AdvancedReport: true },
        { key: "prevented_at", label: "Prevented Time", AdvancedReport: true }
      ],
      tableTabs: [
        { label: "Summary Report", value: "summary_reports" },
        { label: "Detailed Report", value: "detailled_report" }
      ],
      isLoading: false,
      modal: {
        isVisible: {
          edit: false
        },
        activePass: null
      }
    }
  },
  computed: {
    ...mapGetters({
      polaritiesCollection: "polarities/polarities",
      polarityAdvancedReports: "polarities/polarityAdvancedReports"
    }),
    polarities() {
      return this.isAdvancedReportMode
        ? this.polarityAdvancedReports
          ? this.polarityAdvancedReports.map((item) => {
              return { ...item, report_created_at: item.created_at }
            })
          : []
        : this.polaritiesCollection
    },
    totalPolaritiesCount() {
      return this.pagination.total > this.polarities.length
        ? this.pagination.total
        : this.polarities.length
    },
    isAdvancedReportMode() {
      return this.filterParams.activeTab.value === "detailled_report"
    },
    activeDataTableFields() {
      return this.dataTableFields
        .filter((el) =>
          this.isAdvancedReportMode ? el.AdvancedReport : !el.AdvancedReport
        )
        .filter((field) =>
          !this.filterParams.student_sis_id
            ? !field.key.includes("student_sis_id")
            : field
        )
    },
    gradeYears() {
      const gradeYears = []
      const currentYear = new Date().getFullYear()
      const today = moment().format("YYYY-MM-DD HH:mm:ss")
      const newSchoolYear = moment(today).isAfter(
        moment(`${currentYear}-06-30 23:59:59`)
      )
      if (moment(today).year() == currentYear && newSchoolYear) {
        for (let i = 0; i <= currentYear - 2021; i++) {
          gradeYears.push({
            value: [2021 + i, 2022 + i],
            label: `${2021 + i}-${22 + i}`
          })
        }
      } else {
        for (let i = 0; i < currentYear - 2021; i++) {
          gradeYears.push({
            value: [2021 + i, 2022 + i],
            label: `${2021 + i}-${22 + i}`
          })
        }
      }
      return gradeYears
    },
    maxDate() {
      if (this.filterParams.grade_years.value) {
        return new Date(this.filterParams.grade_years.value[1], 5, 30)
      }
      return new Date()
    },
    minDate() {
      if (this.filterParams.grade_years.value) {
        return new Date(this.filterParams.grade_years.value[0], 6, 1)
      }
      return new Date()
    },
    datesParam() {
      return this.filterParams.dates
        ? this.$helpers.currTzDate(this.filterParams.dates.start) +
            "," +
            this.$helpers.currTzDate(this.filterParams.dates.end)
        : null
    }
  },
  created() {
    this.filterParams.activeTab = this.tableTabs[0]
    this.setActiveTableTab(this.filterParams.activeTab)
  },
  mounted() {
    this.initLazyLoading()
  },
  methods: {
    handlePolarities(page, isExport, noLoader, isLazyLoadingMode) {
      this.isLoading = !noLoader
      this.pagination.activePage = page ? page : 1
      const params = {
        page: this.pagination.activePage,
        per_page: this.pagination.per_page.value,
        dates: this.datesParam
      }
      if (this.filterParams.activeTab) {
        params[this.filterParams.activeTab.value] = true
      }
      if (this.filterParams.search_query) {
        params.search_query = this.filterParams.search_query
      }
      if (this.filterParams.sort_query) {
        params.sort = this.filterParams.sort_query
      }
      if (isExport) {
        this.exportCSVPolarities(params)
      } else {
        if (this.isAdvancedReportMode) {
          this.getPolarityAdvancedReports(params, noLoader, isLazyLoadingMode)
        } else {
          this.getPolarities(params, noLoader, isLazyLoadingMode)
        }
      }
    },
    getPolarities(params, noLoader, isLazyLoadingMode) {
      this.isLoading = !noLoader
      this.$store
        .dispatch("polarities/getPolarities", params)
        .then((response) => {
          const data = response.data
          if (data) {
            if (isLazyLoadingMode) {
              this.$store.commit("polarities/PUSH_POLARITIES", data.data)
            } else {
              this.$store.commit("polarities/SET_POLARITIES", data.data)
            }
            this.pagination.total = data.meta.total
            this.pagination.from = data.meta.from
            this.pagination.to = data.meta.to
            this.pagination.pages = Math.ceil(
              data.meta.total / data.meta.per_page
            )
            this.pagination.activePage = Number(this.pagination.activePage)
            this.pagination = JSON.parse(JSON.stringify(this.pagination))
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    getPolarityAdvancedReports(params, noLoader, isLazyLoadingMode) {
      this.isLoading = !noLoader
      this.$store
        .dispatch("polarities/getPolarityAdvancedReports", params)
        .then((response) => {
          const data = response.data
          if (data) {
            if (!isLazyLoadingMode) {
              this.$store.commit(
                "polarities/SET_POLARITY_ADVANCED_REPORTS",
                data.data
              )
            } else {
              this.$store.commit(
                "polarities/PUSH_POLARITY_ADVANCED_REPORTS",
                data.data
              )
            }
            this.pagination.total = data.meta.total
            this.pagination.from = data.meta.from
            this.pagination.to = data.meta.to
            this.pagination.pages = Math.ceil(
              data.meta.total / data.meta.per_page
            )
            this.pagination.activePage = Number(this.pagination.activePage)
            this.pagination = JSON.parse(JSON.stringify(this.pagination))
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    exportCSVPolarities(params) {
      this.isLoading = true
      if (this.pagination.per_page.label == "All entries") {
        params.all_entries = true
      }
      this.$store
        .dispatch("polarities/getCSVpolaritiesExport", {
          ...params,
          student_sis_id: this.filterParams.student_sis_id
        })
        .then((response) => {
          if (response.data) {
            this.downloadCSVExport(response.data)
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    downloadCSVExport(data) {
      const csvDataForExport = "data:text/csv;charset=utf-8," + data
      const encodedUri = encodeURI(csvDataForExport)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("target", "_blank")
      link.setAttribute("download", "polarities.csv")
      document.body.appendChild(link)
      link.click()
    },
    searchByQuery(value, type) {
      clearInterval(this.searchTimeOut)
      this.searchTimeOut = setTimeout(() => {
        this.handleQuerySearch(value, type)
      }, 500)
    },
    handleQuerySearch(value, type) {
      const query = value.toString()
      if (
        query.replace(/\s/g, "").length > 0 ||
        query.replace(/\s/g, "").length === 0
      ) {
        this.filterParams.search_query = ""
        if (type && type === "column") {
          this.columnSearchKeys.globalQuery = ""
          for (const key in this.columnSearchKeys) {
            if (Object.hasOwnProperty.call(this.columnSearchKeys, key)) {
              const columnData = this.columnSearchKeys[key]
              if (columnData.value) {
                columnData.column.forEach((col) => {
                  this.filterParams.search_query =
                    this.filterParams.search_query +
                    `${col}:${
                      col === "times_triggered"
                        ? columnData.value
                        : '"' + columnData.value + '"'
                    }, `
                })
              }
            }
          }
          this.filterParams.search_query = this.filterParams.search_query.slice(
            0,
            -2
          )
        } else {
          this.resetSearchQuery()
          this.columnSearchKeys.globalQuery = query
          this.filterParams.search_query = query ? '"' + query + '"' : query
        }
        // this.clearFilterParams();
        this.handlePolarities()
      }
    },
    sortByColumn(column) {
      const columnName = this.columnSearchKeys[column.column]
        ? this.columnSearchKeys[column.column].sortBy
        : column.column
      this.filterParams.sort_query = `${columnName}:${
        column.asc ? "asc" : "desc"
      }`
      this.handlePolarities()
    },
    deletePolarity(polarityID) {
      if (polarityID) {
        this.isLoading = true
        this.$store
          .dispatch("polarities/deletePolarity", polarityID)
          .then(() => {
            this.$store.commit("polarities/DELETE_POLARITY", polarityID)
            this.isLoading = false
            this.pagination.total = this.pagination.total - 1
          })
          .catch(() => (this.isLoading = false))
      }
    },
    updatePolarityStatus(polarityID) {
      if (polarityID) {
        this.isLoading = true
        this.$store
          .dispatch("polarities/updatePolarityStatus", polarityID)
          .then((response) => {
            const data = response.data.data
            if (data) {
              this.$store.commit("polarities/UPDATE_POLARITY_STATUS", data)
            }
            this.isLoading = false
          })
          .catch(() => (this.isLoading = false))
      }
    },
    setPerPage(option) {
      if (option) {
        this.isLazyLoadingMode = option.label === "All entries"
        this.pagination.per_page = option
        this.handlePolarities()
      }
    },
    setActivePage(page) {
      this.pagination.activePage = page
      this.handlePolarities(this.pagination.activePage)
      this.$helpers.scrollToTop()
    },
    setActiveTableTab(tab) {
      this.filterParams.sort_query = ""
      this.resetSearchQuery()
      this.filterParams = {
        grade_years: this.gradeYears
          ? this.gradeYears[this.gradeYears.length - 1]
          : [],
        student_sis_id: this.filterParams.student_sis_id
      }
      this.filterParams.activeTab = tab
      this.setCalendarDates()
    },
    resetSearchQuery() {
      this.filterParams.search_query = ""
      this.columnSearchKeys = {
        globalQuery: "",
        first_user: {
          value: "",
          column: ["first_user.name"],
          sortBy: "first_user.name"
        },
        second_user: {
          value: "",
          column: ["second_user.name"],
          sortBy: "second_user.name"
        },
        times_triggered: {
          value: "",
          column: ["times_triggered"],
          sortBy: "times_triggered"
        },
        message: { value: "", column: ["message"], sortBy: "message" },
        created_at: {
          value: "",
          column: ["created_at.raw"],
          sortBy: "created_at"
        },
        status: { value: "", column: ["status_string"], sortBy: "status" },

        user: {
          value: "",
          column: ["user.name"],
          sortBy: "user.name"
        },
        destination: {
          value: "",
          column: ["destination.name"],
          sortBy: "destination.name"
        },
        out_user: {
          value: "",
          column: ["out_user.name"],
          sortBy: "out_user.name"
        },
        prevented_from: {
          value: "",
          column: ["prevented_from"],
          sortBy: "prevented_from"
        },
        report_created_at: {
          value: "",
          column: ["prevented_at.raw"],
          sortBy: "prevented_at"
        },
        prevented_at: {
          value: "",
          column: ["prevented_time.raw"],
          sortBy: "prevented_time"
        }
      }
    },
    resetParams() {
      this.filterParams = {
        search_query: "",
        sort_query: "",
        activeTab: this.tableTabs[0],
        student_sis_id: this.filterParams.student_sis_id
      }
    },
    refreshDataTable() {
      this.resetParams()
      this.resetSearchQuery()
      this.handlePolarities(1, false, true)
    },
    initLazyLoading() {
      const body = document.getElementsByClassName("main-scroll-container")[0]
      if (body) {
        body.onscroll = () => {
          if (
            this.isLazyLoadingMode &&
            this.polarities &&
            this.polarities.length &&
            this.pagination.total > this.polarities.length
          ) {
            if (body.offsetHeight + body.scrollTop + 1 >= body.scrollHeight) {
              this.pagination.activePage = this.pagination.activePage + 1
              this.handlePolarities(
                this.pagination.activePage,
                false,
                false,
                true
              )
            }
          }
        }
      }
    },
    setCalendarDates() {
      this.filterParams.dates = {
        start: this.minDate,
        end: this.maxDate
      }
      this.handlePolarities()
    }
  }
}
</script>
